import { eventEngine } from './eventEngine';
import { eventStore } from './eventStore';
import type { DynamicEvent, ActiveEvent, EventDefinition } from '@/types/dynamicEvents';

// Import event definitions
// import historicalEvents from '@/data/events/historicalEvents.json';
// import reactiveEvents from '@/data/events/reactiveEvents.json';
import developmentRiskEvents from '@/data/events/developmentRiskEvents.json' with { type: 'json' };
// import pressEraEvents from '@/data/events/pressEraEvents.json';
import phaseProgressionEvents from '@/data/events/phaseProgressionEvents.json' with { type: 'json' };
import phaseStartEvents from '@/data/events/phaseStartEvents.json' with { type: 'json' };

// Global initialization flag
let isInitialized = false;

export function initializeEventSystem() {
  if (isInitialized) {
    // console.log('Event system already initialized');
    return;
  }

  // console.log('Initializing global event system...');
  
  // Load event definitions
  const combinedDefinitions: EventDefinition = {
    events: [
      // ...historicalEvents.events as DynamicEvent[],
      // ...reactiveEvents.events as DynamicEvent[],
      ...developmentRiskEvents.events as DynamicEvent[],
      // ...pressEraEvents.events as DynamicEvent[],
      ...phaseProgressionEvents.events as DynamicEvent[],
      ...phaseStartEvents.events as DynamicEvent[]
    ],
    chains: [], // historicalEvents.chains || [],
    scenarios: [] // historicalEvents.scenarios || []
  };
  
  eventEngine.loadEventDefinitions(combinedDefinitions);
  
  // Set up event listener
  eventEngine.addListener((newEvent: ActiveEvent) => {
    console.log('Event system: New event -', newEvent.event.title, 'type:', newEvent.event.type);
    eventStore.addEvent(newEvent);
  });
  
  isInitialized = true;
  // console.log('Event system initialized with', combinedDefinitions.events.length, 'events');
}

// Initialize immediately when module loads
initializeEventSystem();